export default __webpack_public_path__ + "static/media/logo.19b41e4d.svg";